import React from "react";
import "./pop_up.css";

const POPUP_IMAGE = "/transparencia2026.jpg";
const DOCUMENT_URL = "https://transparenciadocs.hidalgo.gob.mx/dependencias/Semot/dir3/2026/Transparencia/TRANSP_EN_CORTO_CONVOCATORIA_2026.pdf";

const Popup = ({ onClose, visible }) => {

  if (!visible) {
    return null;
  }

  const openDocument = () => {
    window.open(DOCUMENT_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <div 
      className="popup-overlay" 
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <button 
          onClick={onClose}
          className="close-btn"
          type="button"
          aria-label="Cerrar convocatoria"
        >
          ×
        </button>
        <img
          src={POPUP_IMAGE}
          alt="Concurso Nacional Transparencia en Corto 2026"
          className="popup-image"
        />
        <button className="document-btn" type="button" onClick={openDocument}>
          Ver documento
        </button>
      </div>
    </div>
  );
};

export default Popup;
